// Function copied from gravity-blocks Gravity global functions - Needed for Filters index.js
export default function updateHistory(url, addHistoryEntry) {
    if (addHistoryEntry) {
        window.history.pushState(url, '', url);
    } else {
        window.history.replaceState(url, '', url);
    }
}
